    <template>
   <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6">
      <v-card ref="form">
        <v-card-title> Create Control Drug </v-card-title>
        <v-card-text>
                  <v-text-field
                    v-model="name"
                    label="Control Drug Name"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="directive"
                    label="Directives"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="pharmacy"
                    label="Pharmacy"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="quantityOrder"
                    label="Quantity Order"
                    type="number"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="quantityReceived"
                    label="Quantity Receive"
                    type="number"
                    required
                  ></v-text-field>
                    <v-datetime-picker label="Receive Date & Time"
                                   v-model="receiveDateTime" timePickerFormat="24hr"
                                   dateFormat="dd-MM-yyyy">
                    </v-datetime-picker>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" class="mr-12">
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="startDate"
                                label="Start Date"  
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="startDate" no-title scrollable
                              @input="menu1 = false"
                            >
                            </v-date-picker>
                          </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="ml-12 pl-2">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="endDate"
                                label="End Date"  
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="endDate" no-title scrollable
                              @input="menu2 = false"
                            >
                            </v-date-picker>
                          </v-menu>
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-model="witness"
                    label="Witness"
                    required
                  ></v-text-field>
                  <v-btn
                    color="warning"
                    @click="register"
                  >
                    Submit
                  </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
   </v-row>
</template>

<script>
import {mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
    name:'registerControlDrug',
    data () {
      return {
        name: '',
        directive: '',
        receiveDateTime:'',
        pharmacy: '',
        quantityOrder:  0,
        quantityReceived: 0,
        startDate:null,
        endDate: null,
        resident: '',
        user: '',
        witness:'',
        menu1: false,
        menu2: false,
      }
    },
    computed: {
        ...mapGetters([
           'getLoggedUser'
        ]),
    },
     created() {
       this.getLoggedInUser();
    },
    methods: {
      ...mapActions([
          'register_control_drug',
          'getLoggedInUser',
      ]),
      register () {
        this.user = this.getLoggedUser.user.id,
        delete this.$data.date1;
        delete this.$data.date2;
        delete this.$data.menu1;
        delete this.$data.menu2;

        this.resident = this.$route.params.residentId;
        this.$data.receiveDateTime = this.formatDate(this.$data.receiveDateTime);
        this.$data.startDate = this.formatDate(this.$data.startDate);
        this.$data.endDate = this.formatDate(this.$data.endDate);
        this.register_control_drug({
          ...this.$data
        })
        /* eslint-disable */
        .then(response => {
            this.$router.push('/controlDrugRegister')
        })
        .catch(error => {
            console.log(error)
        })
      },
      formatDate(date) {
        date = moment(date).format('DD-MM-YYYY HH:mm');
        return date
      }

    },
}
</script>

<style lang="stylus" scoped>

</style>